import Checkbox from './checkbox'

const Radiobox = props => <Checkbox {...props} radio={true} />

export default Radiobox
